<template>
    <div class="px-4">
      <v-row>
        <v-col cols="12">
          <div class="primary1--text headline font-weight-bold">
            RELAÇÃO DE USUÁRIOS
          </div>
        </v-col>
      </v-row>
      <v-row style="height: 100%;">
        <v-col cols="12">
          <TabelaUsuarios @viewModal="showModal"/>
        </v-col>
      </v-row>
      <ModalUsuario v-model="show" ref="modalUsuario"/>
    </div>
</template>

<script>
import TabelaUsuarios from './Shared/TabelaUsuarios'
import ModalUsuario from './Shared/ModalUsuario'

export default {
  components: {
    TabelaUsuarios,
    ModalUsuario
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    showModal (obj) {
      this.$refs.modalUsuario.start(obj)
      this.show = true
    }
  }
}
</script>
